import { render, staticRenderFns } from "./MatchRenderer.vue?vue&type=template&id=061757c4&"
import script from "./MatchRenderer.vue?vue&type=script&lang=js&"
export * from "./MatchRenderer.vue?vue&type=script&lang=js&"
import style0 from "./MatchRenderer.vue?vue&type=style&index=0&id=061757c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports